import { z } from "zod";

import { REQUIRED_ERR_MSG } from "../../constants";

const zTrue = z.literal<boolean>(true, {
  error: REQUIRED_ERR_MSG,
});

export const zAgreements = z.object({
  digital_signature_acknowledged: zTrue,
  certifications_and_resolutions_accepted: zTrue,
  customer_agreement_acknowledged: zTrue,
  ubo_acknowledged: zTrue,
  id_verification_acknowledged: zTrue,
});

export type Agreements = z.infer<typeof zAgreements>;
